import styled from 'styled-components';

export const BehavioralListSC = styled.div``;
